import _get from 'lodash/get'

import { getCurrentSession } from '../../lib/authentication'

const testForUnderwriter = (obj, key) => _get(obj, key, '').includes('underwriter')

export default user => {
  if (!user) {
    return getCurrentSession()
      .then(({ userData }) => { return testForUnderwriter(userData, 'role') })
      .catch(error => {
        console.log(error)
        return false
      })
  }
  return testForUnderwriter(user, 'role')
}
